// Generated by purs version 0.14.4
import * as Control_Category from "../Control.Category/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
var options = {
    sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
    unwrapSingleConstructors: true,
    unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
    unwrapSingleRecordArguments: true,
    fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
};
var defaultEnumEncode = function (dictGeneric) {
    return function (dictGenericEncodeEnum) {
        return function (x) {
            return Foreign_Generic_EnumEncoding.genericEncodeEnum(dictGeneric)(dictGenericEncodeEnum)({
                constructorTagTransform: Control_Category.identity(Control_Category.categoryFn)
            })(x);
        };
    };
};
var defaultEnumDecode = function (dictGeneric) {
    return function (dictGenericDecodeEnum) {
        return function (x) {
            return Foreign_Generic_EnumEncoding.genericDecodeEnum(dictGeneric)(dictGenericDecodeEnum)({
                constructorTagTransform: Control_Category.identity(Control_Category.categoryFn)
            })(x);
        };
    };
};
var defaultEncodeJSON = function (dictGeneric) {
    return function (dictGenericEncode) {
        return function (x) {
            return Foreign_Generic.genericEncodeJSON(dictGeneric)(dictGenericEncode)(options)(x);
        };
    };
};
var defaultEncode = function (dictGeneric) {
    return function (dictGenericEncode) {
        return function (x) {
            return Foreign_Generic.genericEncode(dictGeneric)(dictGenericEncode)(options)(x);
        };
    };
};
var defaultDecodeJSON = function (dictGeneric) {
    return function (dictGenericDecode) {
        return function (x) {
            return Foreign_Generic.genericDecodeJSON(dictGeneric)(dictGenericDecode)(options)(x);
        };
    };
};
var defaultDecode = function (dictGeneric) {
    return function (dictGenericDecode) {
        return function (x) {
            return Foreign_Generic.genericDecode(dictGeneric)(dictGenericDecode)(options)(x);
        };
    };
};
export {
    defaultDecode,
    defaultEncode,
    defaultEnumDecode,
    defaultEnumEncode,
    defaultDecodeJSON,
    defaultEncodeJSON
};
//# sourceMappingURL=index.js.map
